import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { message, setCurrentShow, setHistoryRoute, setTitleAndScrollToTop } from "../../../actions";
import { getBlocks } from "../actions/Blocks";
import {
	answerSurveyQuestion,
	changeSurveyQuestionAnswer,
	completeSurvey,
	downloadSurvey,
	getFirstQuestion,
	getSurveys,
	patchSurveyQuestionReasoning,
	setNextSurveyQuestion,
	setSurveyAnswers,
	setSurveys
} from "../actions/Surveys";
import { downloadDocument, getQuestionnaireDocuments } from "../actions/Documents";
import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import ReactGA from "react-ga";
import { translations } from "../../../config";
import Access from "../../../components/Access";
import Form from "../../../components/Form";

const mapStateToProps = ( state ) =>
{
	return {
		blocksByQuestionnaireId: state.blocksByQuestionnaireId,
		documentsByQuestionnaireId: state.documentsByQuestionnaireId,
		questions: state.questions,
		surveys: state.surveys,
		surveyAnswers: state.surveyAnswers,
		nextSurveyQuestion: state.nextSurveyQuestion,
		historyRoute: state.historyRoute
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getBlocks: ( id ) =>
		{
			dispatch( getBlocks( id ) );
		},
		getSurveys: ( id ) =>
		{
			dispatch( getSurveys( id ) );
		},
		setTestSurvey: ( json ) =>
		{
			dispatch( setSurveys( json ) );
			dispatch( setTitleAndScrollToTop( `${translations.de_DE.words.survey}: ${json.title}` ) );
			dispatch( getQuestionnaireDocuments( json.questionnaire_id ) );
			dispatch( getFirstQuestion( json.questionnaire_id ) );
			dispatch( getBlocks( json.questionnaire_id ) );
		},
		changeSurveyQuestionAnswer: ( survey, question ) =>
		{
			dispatch( changeSurveyQuestionAnswer( survey, question ) );
		},
		answerSurveyQuestion: ( survey, question ) =>
		{
			dispatch( answerSurveyQuestion( survey, question ) );
		},
		patchSurveyQuestionReasoning: ( survey, question ) =>
		{
			dispatch( patchSurveyQuestionReasoning( survey, question ) );
		},
		completeSurvey: ( survey_id ) =>
		{
			dispatch( completeSurvey( survey_id ) );
		},
		downloadSurvey: ( a_survey, a_format ) =>
		{
			dispatch( downloadSurvey( a_survey, a_format ) );
		},
		downloadDocument: ( a_document_id, a_filename ) =>
		{
			dispatch( downloadDocument( a_document_id, a_filename ) );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		},
		setCurrentShow: ( show ) =>
		{
			dispatch( setCurrentShow( show ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		},
		resetComponent: () =>
		{
			dispatch( setSurveyAnswers( null ) );
			dispatch( setNextSurveyQuestion( null ) );
			dispatch( setHistoryRoute( null ) );
		}
	};
};

/**
 * Fragebogenkomponente der GUI
 */
class Surveys extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			answer_id: null,
			selectedQuestionnaireId: null,
			nextSurveyQuestion: null,
			isHovering: {},
			isExpand: {},
			disabledButton: {}
		};
		
		this.handleSubmit = this.handleSubmit.bind( this );
		this.answerQuestionReset = this.answerQuestionReset.bind( this );
		this.answerQuestion = this.answerQuestion.bind( this );
		this.onSelectedAnswerSubmit = this.onSelectedAnswerSubmit.bind( this );
		this.onSelectedAnswerEditSubmit = this.onSelectedAnswerEditSubmit.bind( this );
		this.handleExpand = this.handleExpand.bind( this );
		this.handleEditSurveyReasoning = this.handleEditSurveyReasoning.bind( this );
		this.handleExport = this.handleExport.bind( this );
		this.disableButton = this.disableButton.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		const { surveys, id } = { ...this.props };
		
		if ( id !== undefined )
		{
			if ( id > 0 )
			{
				// App vollständig laden
				this.props.getSurveys( id );
				
				// Google Analytics
				if ( localStorage.getItem( "ga" ) )
				{
					ReactGA.pageview( `${translations.de_DE.routes.surveys}/${id}` );
				}
			}
			else
			{
				// Testen der App
				if ( !surveys )
				{
					const survey = sessionStorage.getItem( "Survey" );
					if ( !survey )
					{
						this.props.message( "Die Session ist ungülig. Bitte starten Sie einen neuen Test." );
						this.props.history.push( this.props.historyRoute ? this.props.historyRoute : translations.de_DE.routes.questionnaires );
					}
					else
					{
						this.props.setTestSurvey( JSON.parse( survey ) );
					}
				}
			}
		}
		
		if ( this.props.questionnaireId !== undefined )
		{
			this.setState( { selectedQuestionnaireId: this.props.questionnaireId } );
		}
		
		this.props.setCurrentShow( null );
		
	} // function componentDidMount()
	
	componentWillUnmount()
	{
		const { surveys, id } = { ...this.props };
		
		// Wenn die Umfrage beendet wurde und ein Seitenwechsel ohne Dialogbestätigung erfolgt, dann die Umfrage abschließen
		if ( this.props.nextSurveyQuestion === null && this.props.surveyAnswers !== null && this.getLastMessage() !== null )
		{
			if ( surveys[id].id > 0 )
			{
				this.props.completeSurvey( surveys[id].id );
			}
			
			// Ggf. Testumfrage löschen
			sessionStorage.removeItem( "Survey" );
		}
		
		this.props.resetComponent();
		
	} // function componentWillUnmount()
	
	componentDidUpdate( a_prevProps )
	{
		const { surveys, id } = { ...this.props };
		
		// Wenn die Umfrage abgeschlossen ist, dann auf die Übersicht umleiten
		if ( surveys && surveys[id] && !!surveys[id].completed_at )
		{
			// TODO Wenn diese Umleitung gesetzt wird, dann wird bei Abschluss der Umfrage diese manchmal als nicht Abgeschlossen angezeigt.
			// Ein erneutes Aufrufen dieser führt zum gewolten Ergebnis.
			this.props.history.push( this.props.historyRoute ? this.props.historyRoute : translations.de_DE.routes.surveys );
		}
		
		if ( this.state.selectedQuestionnaireId === null )
		{
			if ( surveys && surveys[id] )
			{
				this.setState( { selectedQuestionnaireId: surveys[id].questionnaire_id } );
				
				if ( Object.keys( this.props.blocksByQuestionnaireId ).length === 0 )
				{
					this.props.getBlocks( surveys[id].questionnaire_id );
				}
			}
		}
		
	} // function componentDidUpdate(...)
	
	handleSubmit( event, survey, mode )
	{
		switch ( mode )
		{
			/*case "edit":
			 this.props.setCurrentShow( "AnswerSurvey" );
			 this.props.setTitleAndScrollToTop( `${translations.de_DE.words.survey}: ${survey.title}` );
			 this.setState( { selectedQuestionnaireId: survey.questionnaire_id } );
			 this.props.getBlocks( survey.questionnaire_id );
			 this.props.getSurveys( survey.id );
			 break;*/
			
			// Wenn die Umfrage beendet wurde, dann auf die Recherchenübersicht umleiten.
			// Dadurch wird die Methode componentWillUnmount aufgerufen und die Umfrage geschlossen.
			case "complete":
				this.props.history.push( this.props.historyRoute ? this.props.historyRoute : translations.de_DE.routes.surveys );
				break;
			
			default:
				break;
		}
		
		event.preventDefault();
		
	} // function handleSubmit(...)
	
	disableButton( a_target )
	{
		// Es soll nur der aktuelle Button deaktiviert werden um Doppelklicks zu vermeiden
		let button = this.state.disabledButton;
		button.disabled = false;
		
		a_target.disabled = true;
		
		this.setState( { disabledButton: a_target } );
		
	} // function disableButton(...)
	
	answerQuestion( a_event, answer_id )
	{
		const { surveys, id, blocksByQuestionnaireId } = { ...this.props };
		
		this.disableButton( a_event.target );
		
		let nextSurveyQuestion = { ...this.props.nextSurveyQuestion };
		const blockQuestions = blocksByQuestionnaireId[this.state.selectedQuestionnaireId][nextSurveyQuestion.block_id]["questions"];
		const answers = blockQuestions[nextSurveyQuestion.id]["answers"];
		
		nextSurveyQuestion["next_question_id"] = answers[answer_id].next_question_id;
		nextSurveyQuestion["result_text"] = answers[answer_id].result_text;
		nextSurveyQuestion["answer_id"] = answers[answer_id].id;
		
		// Zwischengespeicherte Begründung übernehmen und aus dem State entfernen
		if ( this.state.nextSurveyQuestion !== null )
		{
			nextSurveyQuestion = Object.assign(
				{},
				nextSurveyQuestion,
				{
					reasoning: this.state.nextSurveyQuestion.reasoning
				}
			);
			
			this.setState( { nextSurveyQuestion: null } );
		}
		
		this.props.answerSurveyQuestion( surveys[id], nextSurveyQuestion );
		
	} // function answerQuestion(...)
	
	onSelectedAnswerSubmit( a_event, a_formData )
	{
		this.answerQuestion( a_event, a_formData.answer_id );
		
	} // function onSelectedAnswerSubmit(...)
	
	answerQuestionReset( a_event, answer_id, question )
	{
		const { surveys, id, blocksByQuestionnaireId } = { ...this.props };
		const blockQuestions = blocksByQuestionnaireId[this.state.selectedQuestionnaireId][question.block_id]["questions"];
		const questionAnswer = blockQuestions[question.id]["answers"][answer_id];
		question["next_question_id"] = questionAnswer.next_question_id;
		question["result_text"] = questionAnswer.result_text;
		question["answer_id"] = questionAnswer.id;
		
		this.disableButton( a_event.target );
		
		this.props.changeSurveyQuestionAnswer( surveys[id], question );
		
	} // function answerQuestionReset(...)
	
	onSelectedAnswerEditSubmit( a_event, a_formData, a_question )
	{
		this.answerQuestionReset( a_event, a_formData.answer_id, a_question );
		
	} // function onSelectedAnswerEditSubmit(...)
	
	handleExpand( event, block_id, expand )
	{
		let is_expand = Object.assign(
			{},
			this.state.isExpand,
			{
				[block_id]: expand
			}
		);
		this.setState( { isExpand: is_expand } );
		
	} // function handleExpand(...)
	
	handleRememberSurveyReasoning( reasoning )
	{
		const nextSurveyQuestion = Object.assign(
			{},
			this.props.nextSurveyQuestion,
			{
				reasoning: reasoning
			}
		);
		
		this.setState( { nextSurveyQuestion: nextSurveyQuestion } );
		
	} // function handleRememberSurveyReasoning(...)
	
	handleEditSurveyReasoning( question )
	{
		const { surveys, id } = { ...this.props };
		
		this.props.patchSurveyQuestionReasoning( surveys[id], question );
		
	} // function handleEditSurveyReasoning(...)
	
	getLastMessage()
	{
		const objects = this.props.surveyAnswers;
		const lastAnswer = objects[Object.keys( objects ).pop()];
		
		if ( typeof lastAnswer === "undefined" )
		{
			return null;
		}
		
		const questions = this.props.blocksByQuestionnaireId[this.state.selectedQuestionnaireId][lastAnswer.block_id]["questions"];
		const answers = questions[lastAnswer.id]["answers"];
		
		return answers[lastAnswer.answer_id].result_text;
		
	} // function getLastMessage()
	
	handleExport( a_event, a_survey )
	{
		this.props.downloadSurvey( a_survey );
		
		a_event.preventDefault();
		
	} // function handleExport(...)
	
	handleDocumentDownload( a_event, a_document )
	{
		a_event.preventDefault();
		
		this.props.downloadDocument( a_document.id, a_document.name );
		
	} // function handleDocumentDownload(...)
	
	render()
	{
		const { documentsByQuestionnaireId, surveys, id, nextSurveyQuestion, surveyAnswers, blocksByQuestionnaireId, questions } = { ...this.props };
		const survey = surveys && surveys[id];
		
		let currentBlock = null;
		
		const nextSurveyBlock = survey &&
			nextSurveyQuestion &&
			blocksByQuestionnaireId &&
			blocksByQuestionnaireId.hasOwnProperty( survey.questionnaire_id ) &&
			blocksByQuestionnaireId[survey.questionnaire_id].hasOwnProperty( nextSurveyQuestion.block_id ) &&
			blocksByQuestionnaireId[survey.questionnaire_id][nextSurveyQuestion.block_id];
		
		const lastMessage = nextSurveyQuestion === null && surveyAnswers ? this.getLastMessage() : null;
		
		return (
			<article>
				{
					survey &&
					this.state.selectedQuestionnaireId &&
					Object.keys( blocksByQuestionnaireId ).length > 0 &&
					<section className={"white"}>
						{
							// Umfrage beantworten
							<div className={"col s12 l6 xl7"}>
								<label>Beschreibung</label>
								<p>{survey.description}</p>
							</div>
						}
						{
							<div className={"col s12 l6 xl5 tRight"}>
								{
									survey && survey.survey_article_id > 0 &&
									<Access permissions={[ "export_survey" ]}>
										<button className={"btn-middle red-text light-grey hover-secondary-color pointer"}
										        onClick={( event ) => this.handleExport( event, survey )}
										        download={true}>
											<Icon verticalAlign={"middle"} size={28} iconName={"pdf"}/>
											<span
												className={"label"}>{!nextSurveyQuestion && surveyAnswers ? "Bericht" : "Zwischenbericht"}<br/>erstellen</span>
										</button>
									</Access>
								}
								{
									nextSurveyQuestion === null && surveyAnswers !== null
										? <Modal
											className={"confirm"}
											key={"survey_close_modal"}
											trigger={
												<button>
													<Icon color="#fff" iconName={"leave"}/><span>{translations.de_DE.words.survey} verlassen</span>
												</button>
											}
											footer={
												<React.Fragment>
													<button onClick={( event ) => this.handleSubmit( event, survey, "complete" )} data-modal={"confirm"}>
														<Icon size={14} iconName={"save"}/><span>Ja</span>
													</button>
													<button className={"secondary-color"} data-modal={"close"}><Icon iconName={"discard"}/><span>Nein</span></button>
												</React.Fragment>
											}
										>
											<div className={"tLeft"}>
												<p>Mit dem Verlassen der Recherche ist die Änderung dieser nicht mehr möglich.</p>
												<p>Soll die {translations.de_DE.words.survey} geschlossen werden?</p>
											</div>
										</Modal>
										
										: <Link
											className={"btn"}
											key={`survey_overview`}
											to={this.props.historyRoute ? this.props.historyRoute : translations.de_DE.routes.surveys}>
											<Icon color="#fff" iconName={"leave"}/><span>{translations.de_DE.words.survey} verlassen</span>
										</Link>
								}
							</div>
						}
						{
							documentsByQuestionnaireId.hasOwnProperty( survey.questionnaire_id ) &&
							Object.keys( documentsByQuestionnaireId[survey.questionnaire_id] ).length > 0 &&
							<div className={"col s12"}>
								<h6>Dokumente</h6>
								<div className={"document-list"}>
									{
										Object.keys( documentsByQuestionnaireId[survey.questionnaire_id] )
											.map(
												( a_key ) =>
												{
													const document = documentsByQuestionnaireId[survey.questionnaire_id][a_key];
													
													return [
														document &&
														<div key={`questionnaire_export_id_${this.props.id}`} className={"col s4 m3 l2 xl1 document-item"}>
															<button className={"btn-flat tCenter primary-color-text hover-secondary-color-text hover-light-grey icon-shadow"}
															        onClick={( event ) => this.handleDocumentDownload( event, document )}
															        download={true}>
																<Icon iconName={document.mime_type} size={"100%"}/>
																<label>{document.title}</label>
															</button>
														</div>
													];
												}
											)
									}
								</div>
							</div>
						}
						{
							// Bearbeitete Blöcke mit Antworten anzeigen
							<div className={"col s12"}>
								<ul className="collection with-header">
									{
										// Beantwortete Fragen im zugehörigen Block anzeigen
										surveyAnswers !== null && blocksByQuestionnaireId !== null &&
										Object.keys( surveyAnswers ).map(
											( a_key ) =>
											{
												const question = surveyAnswers[a_key];
												
												// Weitere Antworten anzeigen
												// Wenn das Umfrageende erreicht wurde oder es sich um keinen aktuellen Block handelt
												return ( nextSurveyQuestion === null || nextSurveyQuestion.block_id !== question.block_id ) &&
													<React.Fragment key={`block_last_survey_question_edit_${question.id}`}>
														{
															currentBlock !== question.block_id &&
															<li className="collection-header lighter-grey"
															    key={`last_survey_block_${question.id}`}
															    ref={currentBlock = question.block_id}
															>
																<div className={"col col s8 m9 l10 xl11"}>
																	<h4>{blocksByQuestionnaireId[survey.questionnaire_id][question.block_id].title}</h4>
																	<p>{blocksByQuestionnaireId[survey.questionnaire_id][question.block_id].description}</p>
																</div>
																<span key={`hovering_block_menu_id_${question.block_id}`} className="right">
																<button className="btn btn-small btn-flat hover-light-grey"
																        key={`block_expand_id_${question.block_id}`}
																        onClick={( event ) => this.handleExpand( event, question.block_id, !this.state.isExpand[question.block_id] )}>
																	<Icon iconName={this.state.isExpand[question.block_id] ? "shrink" : "expand"}/>
																</button>
															</span>
															</li>
														}
														{
															( this.state.isExpand[question.block_id] === undefined || !this.state.isExpand[question.block_id] ) &&
															<li className="collection-item" key={`last_survey_question_edit_${question.id}`}>
																<div className={"col s12 m6 l8 xl10"}>
																	{
																		question.note !== null &&
																		<Modal
																			key={"note_modal"}
																			title="Hinweistext"
																			trigger={
																				<button className={"right"}>
																					<Icon verticalAlign={"middle"} size={22} iconName={"help"}/>
																				</button>
																			}
																			footer={
																				<React.Fragment>
																				<span data-modal={"close"}>
																					<Icon iconName={"discard"}/><span>Schließen</span>
																				</span>
																				</React.Fragment>
																			}
																		>
																			
																			<section className={"white"}>
																				<div dangerouslySetInnerHTML={{ __html: question.note }}/>
																			</section>
																		
																		</Modal>
																	}
																	<p dangerouslySetInnerHTML={{ __html: question.question }}/>
																	{
																		!question.binary &&
																		<Form className="col s12 m6 l4 xl2 bottom tCenter answerList setted"
																		      id={`form-select-answer`}
																		      fields={[
																			      {
																				      title: "Wählen Sie eine Antwortmöglichkeit aus",
																				      name: "answer_id",
																				      options: Object.keys( questions[this.state.selectedQuestionnaireId][question.id]["answers"] ).map(
																					      a_key =>
																					      {
																						      const answer = questions[this.state.selectedQuestionnaireId][question.id]["answers"][a_key];
																						
																						      return {
																							      value: answer.id,
																							      title: answer.title
																						      };
																					      }
																				      ),
																				      type: "radio",
																				      required: true,
																				      className: "answerList",
																				      onChecked: ( a_event ) =>
																				      {
																					      question.answer_id = a_event.target.value;
																				      }
																			      }
																		      ]}
																		      errorMessage={( message ) => this.props.message( message, "warning", 5000 )}
																		      values={{ answer_id: question.answer_id }}
																		      submitValue={[
																			      <Icon key={`form-edit-question-icon`} iconName={"next"}/>,
																			      <span key={`form-edit-question-text`}>Antwort ändern</span>
																		      ]}
																		      onSubmit={( a_event, a_formData ) => this.onSelectedAnswerEditSubmit( a_event, a_formData, question )}
																		      additionalFormHtml={
																			      <div className={"form"}>
																				      <label htmlFor={`label_reasoning_question_id_${question.id}`}>Begründung</label>
																				      <input onBlur={( event ) => this.handleEditSurveyReasoning( {
																					      ...question,
																					      reasoning: event.target.value
																				      } )}
																				             id={`label_reasoning_question_id_${question.id}`}
																				             type={"text"}
																				             defaultValue={question.reasoning}
																				      />
																			      </div>
																		      }
																		/>
																	}
																	{
																		question.binary &&
																		<div className={"form"}>
																			<label htmlFor={`label_reasoning_question_id_${question.id}`}>Begründung</label>
																			<input
																				onBlur={( event ) => this.handleEditSurveyReasoning( { ...question, reasoning: event.target.value } )}
																				id={`label_reasoning_question_id_${question.id}`}
																				type={"text"}
																				defaultValue={question.reasoning}
																			/>
																		</div>
																	}
																</div>
																{
																	question.binary &&
																	<div className={"col s12 m6 l4 xl2 bottom"}>
																		{
																			Object.keys( questions[this.state.selectedQuestionnaireId][question.id]["answers"] ).map(
																				a_key =>
																				{
																					const answer = questions[this.state.selectedQuestionnaireId][question.id]["answers"][a_key];
																					
																					return <div key={`button-yes-no-${answer.id}`} className={"col s6"}>
																						<button
																							className={`fullWidth setted ${question.answer_id === answer.id ? "primary-color white-text" : "grey"}`}
																							onClick={( event ) => this.answerQuestionReset( event, answer.id, question )}>
																							{answer.title}
																						</button>
																					</div>;
																				}
																			)
																		}
																	</div>
																}
															</li>
														}
													</React.Fragment>;
											}
										)
									}
									{
										nextSurveyQuestion !== null &&
										<React.Fragment>
											{
												// aktuellen Block anzeigen
												nextSurveyBlock &&
												<li className="collection-header lighter-grey" key={`survey_block_edit_${nextSurveyQuestion.block_id}`}>
													<div>
														<div className={"col s12"}>
															<h4>{nextSurveyBlock.title}</h4>
															<p>{nextSurveyBlock.description}</p>
														</div>
													</div>
												</li>
											}
											{
												// beantwortete Fragen im zugehörigen Block anzeigen
												surveyAnswers !== null &&
												Object.keys( surveyAnswers ).map(
													( a_key ) =>
													{
														const question = surveyAnswers[a_key];
														
														return nextSurveyQuestion.block_id === question.block_id &&
															<li className="collection-item" key={`prev_survey_question_edit_${question.id}`}>
																<div className={"col s12 m6 l8 xl10"}>
																	{
																		question.note !== null &&
																		<Modal
																			key={"note_modal"}
																			title="Hinweistext"
																			trigger={
																				<button className={"right"}>
																					<Icon verticalAlign={"middle"} size={22} iconName={"help"}/>
																				</button>
																			}
																			footer={
																				<React.Fragment>
																				<span className={"margin-right"} data-modal={"close"}>
																					<Icon iconName={"discard"}/><span>Schließen</span>
																				</span>
																				</React.Fragment>
																			}
																		>
																			
																			<section className={"white"}>
																				<div dangerouslySetInnerHTML={{ __html: question.note }}/>
																			</section>
																		
																		</Modal>
																	}
																	<p dangerouslySetInnerHTML={{ __html: question.question }}/>
																	{
																		!question.binary &&
																		<Form className="col s12 m6 l4 xl2 bottom tCenter answerList setted"
																		      id={`form-select-answer`}
																		      fields={[
																			      {
																				      title: "Wählen Sie eine Antwortmöglichkeit aus",
																				      name: "answer_id",
																				      options: Object.keys( questions[this.state.selectedQuestionnaireId][question.id]["answers"] ).map(
																					      a_key =>
																					      {
																						      const answer = questions[this.state.selectedQuestionnaireId][question.id]["answers"][a_key];
																						
																						      return {
																							      value: answer.id,
																							      title: answer.title
																						      };
																					      }
																				      ),
																				      type: "radio",
																				      required: true,
																				      className: "answerList",
																				      onChecked: ( a_event ) =>
																				      {
																					      question.answer_id = a_event.target.value;
																				      }
																			      }
																		      ]}
																		      errorMessage={( message ) => this.props.message( message, "warning", 5000 )}
																		      values={{ answer_id: question.answer_id }}
																		      submitValue={[
																			      <Icon key={`form-edit-question-icon`} iconName={"next"}/>,
																			      <span key={`form-edit-question-text`}>Antwort ändern</span>
																		      ]}
																		      onSubmit={( a_event, a_formData ) => this.onSelectedAnswerEditSubmit( a_event, a_formData, question )}
																		      additionalFormHtml={
																			      <div className={"form"}>
																				      <label htmlFor={`label_reasoning_question_id_${question.id}`}>Begründung</label>
																				      <input onBlur={( event ) => this.handleEditSurveyReasoning( {
																					      ...question,
																					      reasoning: event.target.value
																				      } )}
																				             id={`label_reasoning_question_id_${question.id}`}
																				             type={"text"}
																				             defaultValue={question.reasoning}
																				      />
																			      </div>
																		      }
																		/>
																	}
																	{
																		question.binary &&
																		<div className={"form"}>
																			<label htmlFor={`label_reasoning_question_id_${question.id}`}>Begründung</label>
																			<input onBlur={( event ) => this.handleEditSurveyReasoning( {
																				...question,
																				reasoning: event.target.value
																			} )}
																			       id={`label_reasoning_question_id_${question.id}`}
																			       type={"text"}
																			       defaultValue={question.reasoning}/>
																		</div>
																	}
																</div>
																{
																	question.binary &&
																	<div className={"col s12 m6 l4 xl2 bottom"}>
																		{
																			Object.keys( questions[this.state.selectedQuestionnaireId][question.id]["answers"] ).map(
																				a_key =>
																				{
																					const answer = questions[this.state.selectedQuestionnaireId][question.id]["answers"][a_key];
																					
																					return <div key={`button-yes-no-${answer.id}`} className={"col s6"}>
																						<button
																							className={`fullWidth setted ${question.answer_id === answer.id ? "primary-color white-text" : "grey"}`}
																							onClick={( event ) => this.answerQuestionReset( event, answer.id, question )}>
																							{answer.title}
																						</button>
																					</div>;
																				}
																			)
																		}
																	</div>
																}
															</li>;
													}
												)
											}
											{
												// Aktuelle Frage des Blocks anzeigen
												<li className="collection-item" key={`actual_survey_question_edit_${nextSurveyQuestion.id}`}>
													<div className={"col s12 m6 l8 xl10"}>
														{
															nextSurveyQuestion.note !== null &&
															<Modal
																key={"note_modal"}
																title="Hinweistext"
																trigger={
																	<button className={"right"}>
																		<Icon verticalAlign={"middle"} size={22} iconName={"help"}/>
																	</button>
																}
																footer={
																	<React.Fragment>
																	<span className={"margin-right"} data-modal={"close"}>
																		<Icon iconName={"discard"}/><span>Schließen</span>
																	</span>
																	</React.Fragment>
																}
															>
																
																<section className={"white"}>
																	<div dangerouslySetInnerHTML={{ __html: nextSurveyQuestion.note }}/>
																</section>
															
															</Modal>
														}
														<p dangerouslySetInnerHTML={{ __html: nextSurveyQuestion.question }}/>
														{
															!nextSurveyQuestion.binary &&
															<Form className="col s12 m6 l4 xl2 bottom tCenter"
															      id={`form-select-answer`}
															      fields={[
																      {
																	      title: "Wählen Sie eine Antwortmöglichkeit aus",
																	      name: "answer_id",
																	      options: Object.keys( nextSurveyQuestion["answers"] ).map(
																		      a_key =>
																		      {
																			      const answer = nextSurveyQuestion["answers"][a_key];
																			
																			      return {
																				      value: answer.id,
																				      title: answer.title
																			      };
																		      }
																	      ),
																	      type: "radio",
																	      required: true,
																	      className: "answerList",
																	      onChecked: ( a_event ) =>
																	      {
																		      nextSurveyQuestion.answer_id = a_event.target.value;
																	      }
																      }
															      ]}
															      errorMessage={( message ) => this.props.message( message, "warning", 5000 )}
															      submitValue={[
																      <Icon key={`form-new-question-icon`} iconName={"next"}/>,
																      <span key={`form-new-question-text`}>nächste Frage</span>
															      ]}
															      onSubmit={this.onSelectedAnswerSubmit}
															      additionalFormHtml={
																      <div className={"form margin-top"}>
																	      <label htmlFor={`label_reasoning_question_id_${nextSurveyQuestion.id}`}>Begründung</label>
																	      <input onBlur={( event ) => this.handleRememberSurveyReasoning( event.target.value )}
																	             id={`label_reasoning_question_id_${nextSurveyQuestion.id}`}
																	             type={"text"}
																	      />
																      </div>
															      }
															/>
														}
														{
															nextSurveyQuestion.binary &&
															<div className={"form"}>
																<label htmlFor={`label_reasoning_question_id_${nextSurveyQuestion.id}`}>Begründung</label>
																<input onBlur={( event ) => this.handleRememberSurveyReasoning( event.target.value )}
																       id={`label_reasoning_question_id_${nextSurveyQuestion.id}`}
																       type={"text"}
																/>
															</div>
														}
													</div>
													{
														nextSurveyQuestion.binary &&
														<div className={"col s12 m6 l4 xl2 bottom"}>
															{
																Object.keys( nextSurveyQuestion["answers"] ).map(
																	a_key =>
																	{
																		const answer = nextSurveyQuestion["answers"][a_key];
																		
																		return <div key={`button-yes-no-${answer.id}`} className={"col s6"}>
																			<button className={"fullWidth"}
																			        onClick={( event ) => this.answerQuestion( event, answer.id )}>
																				{answer.title}
																			</button>
																		</div>;
																	}
																)
															}
														</div>
													}
												</li>
											}
										</React.Fragment>
									}
								</ul>
							</div>
						}
						{
							// Ende der Umfrage mit Text ausgeben
							nextSurveyQuestion === null && surveyAnswers !== null && lastMessage !== null &&
							<React.Fragment>
								<div className={"col s12"}>
									<ul className="collection with-header">
										<li className="collection-header lighter-grey">
											<div className={"col s12"}>
												<h4>{translations.de_DE.words.surveys}ende</h4>
											</div>
										</li>
										<li className="collection-item">
											<div className={"col s12"} dangerouslySetInnerHTML={{ __html: lastMessage }}/>
										</li>
									</ul>
								</div>
								<div className={"col s12 tRight"}>
									{
										survey && survey.survey_article_id > 0 &&
										<Access permissions={[ "export_survey" ]}>
											<button className="btn-middle red-text btn-flat light-grey hover-secondary-color margin-right margin-bottom"
											        onClick={( event ) => this.handleExport( event, survey )}
											        download={true}>
												<Icon verticalAlign={"middle"} size={28} iconName={"pdf"}/>
												<span className={"label"}>Bericht<br/>erstellen</span>
											</button>
										</Access>
									}
									<Modal
										className={"confirm"}
										key={"survey_close_modal"}
										trigger={
											<button autoFocus={true}>
												<Icon className={"white-text"} iconName={"leave"}/><span>{translations.de_DE.words.survey} verlassen</span>
											</button>
										}
										footer={
											<React.Fragment>
												<button onClick={( event ) => this.handleSubmit( event, survey, "complete" )} data-modal={"confirm"}>
													<Icon size={14} iconName={"save"}/><span>Ja</span>
												</button>
												<button className={"secondary-color"} data-modal={"close"}><Icon iconName={"discard"}/><span>Nein</span></button>
											</React.Fragment>
										}
									>
										<div className={"tLeft"}>
											<p>Mit dem Verlassen der Recherche ist die Änderung dieser nicht mehr möglich.</p>
											<p>Soll die {translations.de_DE.words.survey} geschlossen werden?</p>
										</div>
									</Modal>
								</div>
							</React.Fragment>
						}
					</section>
				}
			</article>
		);
		
	} // function render()
	
} // class

Surveys = connect(
	mapStateToProps,
	mapDispatchToProps
)( Surveys );

export default withRouter( Surveys );